import React, { Component } from "react"
import "./Index.scss"
import DataHeader from "./containers/DataHeader"
import DataTable from "./containers/DataTable"
import statisticsIcon from "app/styles/images/sp/statistics-selected.svg"
import { observer } from "mobx-react"
import Store from "app/stores/preview/bypass-account"

@observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
  }

  render() {
    const { store } = this
    return (
      <div className="bypass-account bypass">
        <h2 className="page-title"><img alt="" src={statisticsIcon} />子账户</h2>
        <div className="clearfix wrapper-box-first">
          <DataHeader store={store} />
        </div>
        <div>
          <DataTable store={store} onSelect={this.onSelect} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/preview/bypass-account/index.js